import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// React Router v6 BrowserRouter listens to browser navigation events, not this
// legacy standalone history instance. Keep old AppHistory.push/replace callers
// working by notifying BrowserRouter after programmatic navigation.
const notifyBrowserRouter = () => {
  if (typeof window === 'undefined') return;

  if (typeof PopStateEvent === 'function') {
    window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
    return;
  }

  window.dispatchEvent(new Event('popstate'));
};

const originalPush = history.push.bind(history);
history.push = ((to: any, state?: any) => {
  originalPush(to, state);
  notifyBrowserRouter();
}) as typeof history.push;

const originalReplace = history.replace.bind(history);
history.replace = ((to: any, state?: any) => {
  originalReplace(to, state);
  notifyBrowserRouter();
}) as typeof history.replace;

export default history;
